module.exports = __webpack_public_path__ + "img/sort.bc15ec2a.svg";